import React from 'react'
import extractYoutubeEmbedUrl from '../../ui/SongPreview/util/extractYoutubeEmbedUrl'

const YoutubeMusicEmbeddedPlaylistPreview = ({ url }) => {
  if(!url) {
    return null
  }

  const youtubeMusicEmbedUrl = extractYoutubeEmbedUrl(url)
  console.log({ url, youtubeMusicEmbedUrl })
  if(!youtubeMusicEmbedUrl) {
    return (
      <div>
        <p>Unable to load playlist. Please check the URL.</p>
      </div>
    )
  }

  return (
    <iframe
      style={{ borderRadius: 12 }}
      src={youtubeMusicEmbedUrl}
      width="100%"
      height="450"
      frameBorder="0"
      allowFullScreen
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    ></iframe>
  )
}

export default YoutubeMusicEmbeddedPlaylistPreview
